import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../../utils';
import { renderContainerChildren } from '../../utils/RenderUtil';
import { useBreakpointRef } from '../../hooks/useBreakpointRef';
import { useContainerProps } from '../../hooks/useContainerProps';

const BREAKPOINTS = Object.freeze([724, 900]);
const BREAKPOINT_VALUES = Object.freeze([
  {
    section: {
      padding: '24px 0',
    },
    sectionInner: {
      padding: '0 16px',
    },
  },
  {
    section: {
      padding: '30px 0',
    },
    sectionInner: {
      padding: '0 24px',
    },
  },
  {
    section: {
      padding: '30px 0',
    },
    sectionInner: {
      padding: '0 48px',
    },
  },
]);
const TYPE_OVERRIDES = Object.freeze({
  chart: {
    noPadding: true,
  },
});

/** renders a div that is styled to fill the section area */
export const Section = props => {
  props = useContainerProps(props);
  const { ref, breakpointValue } = useBreakpointRef({
    breakpoints: BREAKPOINTS,
    breakpointValues: BREAKPOINT_VALUES,
  });
  const { className, dataObjectType, noBorder, noBottomPadding, noPadding, title, type = 'fullwidth' } = props;
  const overrides = TYPE_OVERRIDES[type] || {};
  const sectionStyle = () => {
    if (!overrides.noPadding) {
      if (noBottomPadding) {
        const sectionPadding = breakpointValue && Object.assign({}, breakpointValue.section);
        if (sectionPadding) {
          sectionPadding.padding = sectionPadding.padding.concat(' 0');
          return sectionPadding;
        }
      }
      return breakpointValue && breakpointValue.section;
    }
    return { padding: 0 };
  };
  const sectionInnerStyle = !overrides.noPadding ? breakpointValue && breakpointValue.sectionInner : { padding: 0 };

  return (
    <div
      className={formatClassName(['section', type, className, { 'no-border': noBorder, 'no-padding': noPadding }])}
      ref={ref}
      style={sectionStyle()}
      data-object-type={dataObjectType}
    >
      <div className="section-inner" style={sectionInnerStyle} data-action="section-inner">
        {title && <h2 className="sr-only">{title}</h2>}
        {renderContainerChildren(props)}
      </div>
    </div>
  );
};

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataObjectType: PropTypes.string,
  noBorder: PropTypes.bool,
  noPadding: PropTypes.bool,
  noBottomPadding: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.oneOf(['cards', 'chart', 'fullwidth', 'list']),
  hideLoader: PropTypes.bool,
};
